module.exports = __webpack_public_path__ + "img/bg-frame-mb.25175803.webp";